export const getSortField = sort => (typeof sort === "string" ? sort.replace(/^-/, "") : undefined);

export const toByKey = fields => Object.fromEntries(fields.filter(field => field.key).map(field => [field.key, field]));

export const toByQs = fields => Object.fromEntries(fields.filter(field => field.qs).map(field => [field.qs, field]));

export const toQs2Label = fields => Object.fromEntries(fields.filter(field => field.qs).map(field => [field.qs, field.label]));

export const keepOnlyFieldQueryStrings = (fields, query) => {
  const qsSet = new Set(fields.filter(field => field.qs).map(field => field.qs));
  const result = {};
  for (const [key, value] of Object.entries(query || {})) {
    if (!qsSet.has(key)) continue;
    if (value === "" || value === null || value === undefined) continue;
    if (Array.isArray(value) && value.length === 0) continue;
    result[key] = value;
  }
  return result;
};

export const omitInvalidFieldSort = (fields, query) => {
  const sortableFieldsSet = new Set(fields.filter(field => field.sorter).map(field => field.field));
  if (!query?.sort || sortableFieldsSet.has(getSortField(query.sort))) return query;
  const queryWithoutSort = { ...query };
  delete queryWithoutSort.sort;
  return queryWithoutSort;
};

export const toDataIndex = field => (field.includes(".") ? field.split(".") : field);